import { ArrowRightIcon, BoxIcon } from "@xola/icons";
import React from "react";
import { Audit, Purchase, PurchaseItem } from "types";
import { NoTranslate } from "../../../Common/NoTranslate";
import { TimelineItem, TimelinePill } from "../TimelineItem";

interface PickupLocationItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audit: Audit;
    showDate?: boolean;
}

export const PickupLocationItem = ({ purchase, item, audit, showDate = false }: PickupLocationItemProps) => {
    if (!PickupLocationItem.supportsAudit(purchase, item, audit)) {
        return null;
    }

    return (
        <TimelineItem
            title="Pickup Location Changed"
            audit={audit}
            icon={<BoxIcon />}
            color="primary"
            showDate={showDate}
            purchase={purchase}
        >
            <div className="flex items-center space-x-4">
                <TimelinePill>
                    <NoTranslate className="whitespace-normal leading-4.5">
                        {audit.data?.items[0]?.pickupLocation?.old || "No Pickup Location"}
                    </NoTranslate>
                </TimelinePill>
                <ArrowRightIcon />
                <TimelinePill>
                    <NoTranslate className="whitespace-normal leading-4.5">
                        {audit.data?.items[0]?.pickupLocation?.new || "No Pickup Location"}
                    </NoTranslate>
                </TimelinePill>
            </div>
        </TimelineItem>
    );
};

PickupLocationItem.supportsAudit = (_purchase: Purchase, _item: PurchaseItem, audit: Audit) => {
    const isPickupLocationChange = audit.data?.items?.some((logItem: any) => logItem.pickupLocation);

    return isPickupLocationChange;
};
